export function getApiKey() {
  const itemSessionStr = localStorage.getItem("apiKey");
  if (itemSessionStr) {
    const itemSession = JSON.parse(itemSessionStr);
    const storedApiKey = itemSession.key;
    const expirationTime = itemSession.expiry;
    if (storedApiKey && expirationTime && Date.now() < expirationTime) {
      return storedApiKey;
    }
  }
  return null;
}

export function getMapGLAccessToken() {
  const mapGLStr = localStorage.getItem("mapGL");
  if (mapGLStr) {
    const mapGLSession = JSON.parse(mapGLStr);
    const storedMapGLAccessToken = mapGLSession.key;
    const expirationTime = mapGLSession.expiry;
    if (
      storedMapGLAccessToken &&
      expirationTime &&
      Date.now() < expirationTime
    ) {
      return storedMapGLAccessToken;
    }
  }
  return null;
}

export function getRandomColor() {
  const randomLightColor = () => Math.floor(Math.random() * 128) + 128; // Ensures light shades
  return `rgb(${randomLightColor()}, ${randomLightColor()}, ${randomLightColor()})`;
}

export function getValidCoordinates(data) {
  return data?.filter((item) => item.latitude && item.longitude);
}

export function truncateText(text, wordLimit) {
  if (!text) return "";
  return (
    text.split(" ").slice(0, wordLimit).join(" ") +
    (text.split(" ").length > wordLimit ? "..." : "")
  );
}

export function compareDate(date1, data2) {
  const dateA = date1 ? new Date(date1).getTime() : null;
  const dateB = data2 ? new Date(data2).getTime() : null;

  if (dateA === null && dateB === null) return 0;
  if (dateA === null) return 1;
  if (dateB === null) return -1;

  // Compare valid dates
  return dateB - dateA;
}
